import classNames from 'classnames';
import Tag, { Props as TagProps } from '../../Atoms/Tag';

export interface Props {
  tag: TagProps;
  linkText: string;
  link: string;
  className?: string;
}

function PillContact({
  tag,
  linkText,
  link,
  className
}: Props) {
  return (
    <div
      className={classNames([
        'flex flex-row flex-wrap items-center justify-between gap-7 rounded-xl bg-sl-gray-light px-7 py-3.5 font-circular text-base',
        className
      ])}
    >
      <Tag
        icon={tag.icon}
        text={tag.text}
        className="font-bold text-sl-blue"
        iconClass="text-sl-indigo"
      />
      <a
        href={link}
        className="text-sl-indigo duration-300 hover:text-sl-blue"
      >
        {linkText}
      </a>
    </div>
  );
}

export default PillContact;
